import React, { useEffect, useState } from 'react'
import TextEditor from '../components/TextEditor'
import Layout from './Layout'
import { RiNewspaperLine, RiEdit2Fill, RiCodeBoxLine, RiEditBoxFill, RiDeleteBin5Line, RiEraserFill, RiSave2Line, RiClipboardFill, RiClipboardLine, RiRefreshLine } from "react-icons/ri";
import EmbedCode from '../components/EmbedCode';
import UploadUrl from '../components/UploadUrl';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { getSaveUsers } from "../utilities/common"
import DeleteModal from '../components/DeleteModal';
import ScoreEdit from '../components/ScoreEdit';
import ReactJWPlayer from "react-jw-player";

import placeholder from "../assets/placeholder.png"
import CreatePoll from '../components/CreatePoll';

import Actions from "../assets/team_logo.json"

const egPollData = {
    "id": "a2b5e6f6-dd12-476a-8629-16b5ba3ba252",
    "title": "IPL",
    "options": [
        {
            "option": "Delhi Capitals",
            "vote": 60,
            "id": "91c0c622-d0fe-4d1a-a3ee-5d2f7a5c6a92"
        },
        {
            "option": "Gujarat Titans",
            "vote": 40,
            "id": "ee86dca4-be8a-4914-b01a-acf47a029ad8"
        },
        {
            "option": "Mumbai Indians",
            "vote": 80,
            "id": "ee86dca4-be8a-4914-b01a-acf47a039ad8"
        },
        {
            "option": "Rajastan Royals",
            "vote": 12,
            "id": "ee86dca4-be8a-4914-b6ba-acf47a029ad8"
        }
    ],
    "type": "POLL"
}


export default function Event() {

    let navigate = useNavigate();

    const [showModal, setShowModal] = useState(false)
    const [eventTitle, setTitle] = useState("")
    const [eventAudio, setAudioUrl] = useState("")
    const [eventVideo, setVideoUrl] = useState("")
    const [eventImage, setImageUrl] = useState("")
    const [eventEmbedd, setEmbeddUrl] = useState("")

    const [eventEditor, setEditor] = useState("")
    const [eidtEventItems, setEditEventItems] = useState()
    const [submitAction, setsubmitAction] = useState("add")


    const [listEventItems, setListEventItems] = useState([])
    const [showEmbedModal, setShowEmbedModal] = useState(false)
    const [embedData, setembedData] = useState()
    const [userData, setUserData] = useState()
    const [uploadUrl, setUploadUrl] = useState("")

    const [uploadUrlType, setUploadUrlType] = useState("")

    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [currentItem, setCurrentItem] = useState()

    const [descriptionError, setDescriptionError] = useState(false)
    const [embeddUrlError, setEmbeddUrlError] = useState(false)

    const [unsptdVideoFormat, setUnsptdVideoFormat] = useState(false)
    const [unsptdAudioFormat, setUnsptdAudioFormat] = useState(false)
    const [unsptdImageFormat, setUnsptdImageFormat] = useState(false)

    const [selectFormatMenu, setSelectFormatMenu] = useState(0)

    const [showScoreUpdateModal, setShowScoreUpdateModal] = useState(false)
    const [scoreUpdateParams, setScoreUpdateParams] = useState("A")

    const [showVisibleButton, setShowVisibleButton] = useState(false)

    const [showCreatePollModal, setShowCreatePollModal] = useState(false)

    const [liveScoreUpdate, setLiveScoreUpdate] = useState()

    const [action, setAction] = useState()
    const [selected_logo, setSelectedLogo] = useState("")

    const [pollData, setPollData] = useState()

    const [liveScoreData, setLiveScoreData] = useState()

    const selectTeams = (team_item) => {
        setSelectedLogo(team_item)
        setAction(team_item)
    }


    let params = useParams();


    let urlParam = window?.location?.href?.split("/")
    localStorage.setItem('urlParam', JSON.stringify(urlParam))

    console.log(urlParam)

    const resetValues = () => {
        setAudioUrl("")
        setVideoUrl("")
        setImageUrl("")
        setEmbeddUrl("")
        setEditor("")
        setUnsptdImageFormat(false)
        setUnsptdVideoFormat(false)
        setUnsptdAudioFormat(false)
    }

    useEffect(() => {
        getEvents()
        let data = getSaveUsers()
        setUserData(data)


        if (data === null) {
            navigate("/")

        }
    }, [])

    const getEvents = () => {
        let data = {
            event_data_by_id: params.id
        }
        axios.post('https://32sb9ff8bc.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Events-Node18', data)
            .then((res) => {
                setListEventItems(res.data.sort(function (a, b) { return new Date(b.event_time) - new Date(a.event_time) }))
                mppInstaFun()
                mppTwitterFun()
            })
            .catch(err => console.log(err))

        // axios.post('https://i5q7r5fa79.execute-api.ap-south-1.amazonaws.com/default/S3ImageUpload',data)
        // .then((res) => {
        //     console.log(res)
        //     setListEventItems(res.data.sort(function (a, b) { return new Date(b.event_time) - new Date(a.event_time) }))
        // })
        // .catch(err => console.error(err))
    }

    const ChangeUploadUrl = (url, type) => {
        setUploadUrlType(type)
        setShowModal(true)
        setUploadUrl(url)
    }

    const convertTime = (datetime) => {

        var hours = new Date(datetime).getHours();
        var minutes = new Date(datetime).getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = addZeroBefore(hours) + ':' + (minutes) + ' ' + ampm;
        return strTime;
    }

    function addZeroBefore(n) {
        return (n < 10 ? '0' : '') + n;
    }

    const addEventPost = () => {

        let audioFormat = ["mp3", "ogg"]
        let imageFormat = ["jpg", "png", "jpeg"]

        let imageArray = eventImage.split(".");
        let eventImageFormat = imageArray[imageArray.length - 1]

        let audioArray = eventAudio.split(".");
        let eventAudioFormat = audioArray[audioArray.length - 1]

        console.log(eventAudioFormat)

        var d = new Date()
        let data = {
            id: uuidv4(),
            event_id: params.id,
            event_title: eventTitle,
            event_description: eventEditor,
            event_imageurl: eventImage,
            event_videourl: eventVideo,
            event_audiourl: eventAudio,
            event_embeddurl: eventEmbedd,
            event_time: d,
            created_at: userData?.profileObj?.email,
            updated_by: "",
            status: "open",
        }
        setUploadUrlType("")

        console.log(data, liveScoreUpdate, pollData)

        if (eventEditor || eventImage || eventVideo || eventAudio || eventEmbedd) {
            setDescriptionError(false)

            if (eventVideo && eventVideo.length > 11) {
                setUnsptdVideoFormat(true)
                return
            } else if (eventImageFormat && imageFormat.includes(eventImageFormat) === false) {
                setUnsptdImageFormat(true)
                return
            } else if (eventAudioFormat && audioFormat.includes(eventAudioFormat) === false) {
                setUnsptdAudioFormat(true)
                return
            }

            if (submitAction === "add") {
                axios.post('https://32sb9ff8bc.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Events-Node18', data)
                    .then((res) => {
                        toast.success('Event added', {
                            position: "bottom-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        resetValues()
                        mppInstaFun()
                        getEvents()

                    })
                    .catch(err => console.log(err))
            } else {
                data.id = eidtEventItems.Id
                data.event_time = eidtEventItems.event_time
                data.created_at= eidtEventItems.created_at
                data.updated_by = userData?.profileObj?.email

                axios.put('https://32sb9ff8bc.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Events-Node18', data)
                    .then((res) => {
                        setsubmitAction("add")
                        toast.success(`Event updated`, {
                            position: "bottom-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        resetValues()
                        mppInstaFun()
                        getEvents()

                    })
                    .catch(err => console.log(err))
            }
        } else {
            setDescriptionError(true)
        }

    }

    function createMarkup(items) {
        return { __html: items };
    }

    const eventDeleteClick = (items) => {

        let data = {
            id: currentItem.Id,
            event_id: currentItem.event_id,
            event_title: currentItem.event_title,
            event_description: currentItem.event_description,
            event_imageurl: currentItem.event_imageurl,
            event_videourl: currentItem.event_videourl,
            event_audiourl: currentItem.event_audiourl,
            event_embeddurl :currentItem.event_embeddurl,
            event_time: currentItem.event_time,
            created_at: currentItem.created_at,
            updated_by: userData?.profileObj?.email,
            status: "delete",
            
        }

        axios.put(`https://32sb9ff8bc.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Events-Node18`, data)
            .then((res) => {
                setShowDeleteModal(false)
                getEvents()
                resetValues()

                toast.success('Event deleted', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
            .catch(err => console.log(err))
    }

    const evenetEditClick = (items) => {
        setEditEventItems(items)

        setsubmitAction("edit")

        setAudioUrl(items.event_audiourl)
        setVideoUrl(items.event_videourl)
        setImageUrl(items.event_imageurl)
        setEditor(items.event_description)
        setEmbeddUrl(items.event_embeddurl)

    }

    const previewClick = () => {
        navigate(`/preview/${params.id}/${params.name}`);

    }
    const embedCodeClick = () => {
        let data = {
            Id: params.id,
            event_name: params.name
        }
        setembedData(data)
        setShowEmbedModal(true)
    }

    const clearAll = () => {
        setTitle("")
        setVideoUrl("")
        setImageUrl("")
        setAudioUrl("")
        setEmbeddUrl("")
        setEditor("")
    }

    const dateFormat = (datetime) => {
        const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        let date

        if (new Date().getFullYear() > new Date(datetime).getFullYear()) {
            date = month[new Date(datetime).getMonth()] + " " + new Date(datetime).getDate() + ", " + new Date(datetime).getFullYear()
        } else {
            date = month[new Date(datetime).getMonth()] + " " + new Date(datetime).getDate()
        }

        return date
    }

    const cancelEventPost = () => {
        clearAll()
        setsubmitAction("add")
    }
    const ClearField = (inputFiled) => {
        setVideoUrl("")
        setImageUrl("")
        setAudioUrl("")
        setEditor("")
        setEmbeddUrl("")
    }

    const pasteFromClipboard = (inputField) => {
        if (inputField == "audio") {
            navigator.clipboard.readText()
                .then(text => setAudioUrl(text))
        } else if (inputField == "image") {
            navigator.clipboard.readText()
                .then(text => setImageUrl(text))
        } else if (inputField == "video") {
            navigator.clipboard.readText()
                .then(text => setVideoUrl(text))
        } else if (inputField == "editor") {
            navigator.clipboard.readText()
                .then(text => setEditor(text))
        } else if(inputField == "embedurl"){
            navigator.clipboard.readText()
                .then(text => setEmbeddUrl(text))
        }
    }

    const mppTwitterFun = () => {
        // window.twttr = (function (d, s, id) {
        //     var t, js, fjs = d.getElementsByTagName(s)[0];
        //     if (d.getElementById(id)) return; js = d.createElement(s); js.id = id;
        //     js.src = "https://platform.twitter.com/widgets.js"; fjs.parentNode.insertBefore(js, fjs);
        //     return window.twttr || (t = { _e: [], ready: function (f) { t._e.push(f) } });
        // }(document, "script", "twitter-wjs"));

        var s = document.createElement("script");
        s.src = "https://platform.twitter.com/widgets.js";
        s.async = true;
        document.getElementsByTagName('head')[0].appendChild(s);

    }

    const mppInstaFun = () => {
        if (window.instgrm) {
          window.instgrm.Embeds.process()
        }
        var s = document.createElement("script");
        s.type= "text/javascript";
        s.src = "https://www.instagram.com/embed.js";
        s.async = true;
        document.getElementsByTagName('head')[0].appendChild(s);
      }

    const changeFormat = (e) => {
        liveScoreUpdateFun("format", e.target.value)
        setSelectFormatMenu(parseInt(e.target.value))
    }

    const editTeamUpdate = (team) => {
        setScoreUpdateParams(team)
        setShowScoreUpdateModal(true)
    }

    const editScoreClick = () => {
        setShowVisibleButton(true)
        liveScoreUpdate.id = uuidv4();
        liveScoreUpdate.type = "SCORE"
    }

    const createPollClick = () => {
        setShowCreatePollModal(true)
    }

    const liveScoreUpdateFun = (name, data) => {
        setLiveScoreUpdate(prevState => ({
            ...prevState,
            [name]: data
        }));


    }

    const setTeamDetailsFun = (data) => {
        if (scoreUpdateParams == "A") {
            liveScoreUpdateFun("team_name_A", data.team_name_A)
            liveScoreUpdateFun("team_logo_A", data.logo_A)
        } else {
            liveScoreUpdateFun("team_name_B", data.team_name_B)
            liveScoreUpdateFun("team_logo_B", data.logo_B)
        }


    }

    const scoreUpdate = () => {
        console.log(liveScoreUpdate)

    }

    const getPollDate = (data) => {
        setPollData(data)

    }

    const votePercentagecalculator = (item) => {

        var total = egPollData.options.reduce(function (a, b) { return a.vote + b.vote; });
        console.log(total)

        let percentage = (item?.vote * 100) / total

        return `${Math.round(percentage)}%`

    }


    return (
        <div>
            <Layout>
                <div className="row">
                    <h4 className='p-0'>{submitAction === "edit" ? "Edit" : "Add"} News</h4>

                    {/* {params.category !== "0" ?
                        <div className="card border-0 l-event-post p-0 mb-3">
                            <div className="l-event-post-header p-2">
                                <h3 className="m-0">Score</h3>
                            </div> */}
                            {/* {params.category == "1" ?
                                <div className='l-score-update px-2'>
                                    <div className='m-3 d-flex align-items-center'>
                                        <label className='me-2'>Format</label>
                                        <select class="form-select" aria-label="Action" style={{ width: "30vh" }} onChange={(e) => changeFormat(e)}>
                                          
                                            <option value="1">Test</option>
                                            <option value="2">One Day</option>
                                            <option value="3">T20</option>
                                        </select>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 text-center'>
                                            <div className='d-flex justify-content-center align-items-center mb-2'>
                                                {showVisibleButton ?
                                                    <img src={liveScoreUpdate?.team_logo_A ? `https://images.mathrubhumi.com/images/liveblog/logos/${liveScoreUpdate?.team_logo_A}.png` : placeholder} style={{ width: "35px", border: "1px dashed #dcdcdc", padding: "2px" }} className="me-2 l-cursor" onClick={() => editTeamUpdate("A")}></img> :
                                                    <img src={liveScoreUpdate?.team_logo_A ? `https://images.mathrubhumi.com/images/liveblog/logos/${liveScoreUpdate?.team_logo_A}.png` : placeholder} style={{ width: "30px" }} className="me-2"></img>}
                                                <h6 className='m-0'>{liveScoreUpdate?.team_name_A ? liveScoreUpdate?.team_name_A : "Team A"}</h6>
                                            </div>
                                            <div className='l-score-section d-flex align-items-center mb-2'>
                                                <input type="number" class="form-control" id="l-live-score-ing1" placeholder="runs" maxLength={65} required onChange={(e) => liveScoreUpdateFun("ing1-runs-A", e.target.value)} />
                                                <p className='m-0 px-2'>/</p>
                                                <input type="number" class="form-control" id="l-live-wickets-ing1" placeholder="wickets" maxLength={65} required onChange={(e) => liveScoreUpdateFun("ing1-wickets-A", e.target.value)} />
                                            </div>
                                            {selectFormatMenu === 0 ?
                                                <div className='l-score-section d-flex align-items-center'>
                                                    <input type="text" class="form-control" id="l-live-wickets-ing2" placeholder="runs" maxLength={65} required onChange={(e) => liveScoreUpdateFun("ing2-runs-A", e.target.value)} />
                                                    <p className='m-0 px-2'>/</p>
                                                    <input type="text" class="form-control" id="l-live-wickets-ing2" placeholder="wickets" maxLength={65} required onChange={(e) => liveScoreUpdateFun("ing2-wickets-A", e.target.value)} />
                                                </div> : ""}
                                            <div className='l-score-section d-flex align-items-center mt-2'>
                                                <input type="text" class="form-control" id="l-live-overs-ing1" placeholder="overs" maxLength={65} required style={{ width: "46%" }} onChange={(e) => liveScoreUpdateFun("ing1-overs-A", e.target.value)} />
                                                <h6 className='m-0 ps-2'>Overs</h6>
                                            </div>
                                        </div>
                                        <div className='col-md-4 text-center '>
                                            <h6>VS</h6>
                                            <h6 className='pt-2 '>1st innings</h6>
                                            {selectFormatMenu === 0 ?
                                                <h6 className='pt-2 '>2nd innings</h6> : ""}

                                        </div>
                                        <div className='col-md-4 text-center'>
                                            <div className='d-flex justify-content-center align-items-center mb-2'>
                                                {showVisibleButton ?
                                                    <img src={liveScoreUpdate?.team_logo_B ? `https://images.mathrubhumi.com/images/liveblog/logos/${liveScoreUpdate?.team_logo_B}.png` : placeholder} style={{ width: "35px", border: "1px dashed #dcdcdc", padding: "2px" }} className="me-2 l-cursor" onClick={() => editTeamUpdate("b")}></img> :
                                                    <img src={liveScoreUpdate?.team_logo_B ? `https://images.mathrubhumi.com/images/liveblog/logos/${liveScoreUpdate?.team_logo_B}.png` : placeholder} style={{ width: "30px" }} className="me-2"></img>}
                                                <h6 className='m-0'>{liveScoreUpdate?.team_name_B ? liveScoreUpdate?.team_name_B : "Team B"}</h6>
                                            </div>
                                            <div className='l-score-section d-flex align-items-center mb-2'>
                                                <input type="text" class="form-control" id="l-live-score-ing1" placeholder="runs" maxLength={65} required onChange={(e) => liveScoreUpdateFun("ing1-runs-B", e.target.value)} />
                                                <p className='m-0 px-2'>/</p>
                                                <input type="text" class="form-control" id="l-live-wickets-ing1" placeholder="wickets" maxLength={65} required onChange={(e) => liveScoreUpdateFun("ing1-wickets-B", e.target.value)} />
                                            </div>
                                            {selectFormatMenu === 0 ?
                                                <div className='l-score-section d-flex align-items-center'>
                                                    <input type="text" class="form-control" id="l-live-wickets-ing2" placeholder="runs" maxLength={65} required onChange={(e) => liveScoreUpdateFun("ing2-runs-B", e.target.value)} />
                                                    <p className='m-0 px-2'>/</p>
                                                    <input type="text" class="form-control" id="l-live-wickets-ing2" placeholder="wickets" maxLength={65} required onChange={(e) => liveScoreUpdateFun("ing2-wickets-B", e.target.value)} />
                                                </div> : ""}

                                            <div className='l-score-section d-flex align-items-center mt-2'>
                                                <input type="text" class="form-control" id="l-live-overs-ing1" placeholder="overs" maxLength={65} required style={{ width: "46%" }} onChange={(e) => liveScoreUpdateFun("ing1-overs-B", e.target.value)} />
                                                <h6 className='m-0 ps-2'>Overs</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row pt-0 pb-0'>
                                        <div className='col-md-12 pt-0'>
                                            <input type="text" class="form-control" id="l-live-score-summery" placeholder="score summery" maxLength={65} required onChange={(e) => liveScoreUpdateFun("score-summery", e.target.value)} />
                                        </div>
                                    </div>

                                </div> : ""} */}

                            {/* {params.category == "2" ?
                                <div className='l-score-update-football px-2'> */}

                                    {/* <div className='col-md-12 d-flex justify-content-end pt-3'>
                                        <div className="d-flex l-event-actinos-btn">
                                            <button type="button" class="btn mx-2 d-flex align-items-center" onClick={() => editScoreClick()}><RiEdit2Fill className="mx-1" size={20}></RiEdit2Fill>Edit</button>
                                            <button type="button" class="btn mx-2 d-flex align-items-center"><RiNewspaperLine className="mx-1" size={20}></RiNewspaperLine>Update</button>
                                        </div>

                                    </div> */}

                                    {/* <div className='l-score-heading pt-3'>
                                        <div className='row mb-2'>
                                            <div className='col-md-4 justify-content-end d-flex align-items-center'>
                                                {showVisibleButton ?
                                                    <img src={liveScoreUpdate?.team_logo_A ? `https://images.mathrubhumi.com/images/liveblog/logos/${liveScoreUpdate?.team_logo_A}.png` : placeholder} style={{ width: "35px", border: "1px dashed #dcdcdc", padding: "2px" }} className="me-2 l-cursor" onClick={() => editTeamUpdate("A")}></img> :
                                                    <img src={liveScoreUpdate?.team_logo_A ? `https://images.mathrubhumi.com/images/liveblog/logos/${liveScoreUpdate?.team_logo_A}.png` : placeholder} style={{ width: "30px" }} className="me-2"></img>}
                                                <h6 className='m-0'>{liveScoreUpdate?.team_name_A ? liveScoreUpdate?.team_name_A : "Team A"}</h6>
                                            </div>
                                            <div className='col-md-4 text-center'>
                                                <h6 className='m-0'>VS</h6>
                                            </div>
                                            <div className='col-md-4 justify-content-start d-flex align-items-center'>
                                                {showVisibleButton ?
                                                    <img src={liveScoreUpdate?.team_logo_B ? `https://images.mathrubhumi.com/images/liveblog/logos/${liveScoreUpdate?.team_logo_B}.png` : placeholder} style={{ width: "35px", border: "1px dashed #dcdcdc", padding: "2px" }} className="me-2 l-cursor" onClick={() => editTeamUpdate("B")}></img> :
                                                    <img src={liveScoreUpdate?.team_logo_B ? `https://images.mathrubhumi.com/images/liveblog/logos/${liveScoreUpdate?.team_logo_B}.png` : placeholder} style={{ width: "30px" }} className="me-2"></img>}
                                                <h6 className='m-0'>{liveScoreUpdate?.team_name_B ? liveScoreUpdate?.team_name_B : "Team B"}</h6>
                                            </div>
                                        </div>
                                        <div className='row pt-1'>
                                            <div className='col-md-6'>
                                                <input type="text" class="form-control" id="team_goal_A" placeholder="goal" maxLength={65} required onChange={(e) => liveScoreUpdateFun("team_goal_A", e.target.value)} />
                                            </div>
                                            <div className='col-md-6'>
                                                <input type="text" class="form-control" id="team_goal_B" placeholder="goal" maxLength={65} required onChange={(e) => liveScoreUpdateFun("team_goal_B", e.target.value)} />
                                            </div>
                                        </div>
                                    </div>

                                </div> : ""} */}


                            {/* <div className='row'>

                                <div className='col-md-12 '>
                                    <div className="d-flex justify-content-center text-center">
                                        {showVisibleButton ? <>
                                            <button type="button" class="btn btn-primary" onClick={() => setShowVisibleButton(false)}>save</button>
                                            <button type="button" class="btn btn-danger" onClick={() => setShowVisibleButton(false)}>Cancel</button></> :
                                            <>
                                                <button type="button" class="btn mx-2 d-flex align-items-center btn-primary px-5" onClick={() => editScoreClick()}><RiEdit2Fill className="mx-1" size={20}></RiEdit2Fill>Edit</button>
                                                <button type="button" class="btn mx-2 d-flex align-items-center btn-secondary" onClick={() => scoreUpdate()}><RiNewspaperLine className="mx-1" size={20}></RiNewspaperLine>Update</button>

                                            </>}

                                    </div>

                                </div>
                            </div>
                        </div> : ""} */}

                    <div className="col-md-6 p-0 pe-md-3 mb-3">
                        <div className="l-event-post px-3 py-4 l-event-post-container">
                            <form>

                                {/* <div class="mb-3">
                                    <label class="form-label fw-bold">Time</label>
                                    <input type="time" class="form-control" name="title" onChange={(e) => setTitle(e.target.value)} />
                                    <TimepickerComponent></TimepickerComponent>
                                </div> */}

                                 <div className="d-flex justify-content-end">
                                    <p className=" l-cursor" onClick={() => clearAll()}><RiEraserFill className="mx-2" size="18"></RiEraserFill>Clear all</p>
                                </div> 


                                <div class="mb-3">
                                    <div className='d-flex justify-content-between'>
                                        <div>
                                            <label for="exampleFormControlTextarea1" class="form-label fw-bold">Description</label>
                                        </div>
                                        <div>
                                            <RiEraserFill className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Clear text" onClick={() => setEditor("")}></RiEraserFill>
                                            <RiClipboardLine className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Paste clipboard" onClick={() => pasteFromClipboard("editor")}></RiClipboardLine>
                                        </div>
                                    </div>

                                    <TextEditor editorResetDate={eventEditor} editorData={(data) => setEditor(data)}></TextEditor>
                                    {descriptionError ? <span style={{ color: "red" }}>*description is required</span> : ""}
                                </div>

                                {/* <div className='d-flex justify-content-between'>

                                    <div className='mb-2'>
                                        <button className='btn btn-secondary' style={{ borderRadius: "none" }} type='button' onClick={() => createPollClick()}>Create Poll</button>
                                    </div>
                                    {params.category == "1" ?
                                        <div class="mb-3 d-flex align-items-center">
                                            <label className='me-2'>Action :</label>
                                            <div className='d-flex align-items-center'>

                                                {Actions.cricket_actions.map((items, index) => (
                                                    <img className="mx-2 l-cursor p-1" src={`https://images.mathrubhumi.com/images/liveblog/actions/${items}.png`} style={{ border: `2px solid ${selected_logo == items ? "#4990e0" : "white"}` }} onClick={() => selectTeams(items)}></img>
                                                ))}

                                            </div>

                                        </div> : ""}

                                </div> */}

                                <div class="mb-3 row d-flex align-items-end p-0">
                                    <div class="col-md-12">
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <label for="exampleFormControlTextarea1" class="form-label fw-bold">Embedd URL</label>
                                            </div>
                                            <div>
                                                <RiEraserFill className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Clear text" onClick={() => setEmbeddUrl("")}></RiEraserFill>
                                                <RiClipboardLine className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Paste clipboard" onClick={() => pasteFromClipboard("embedurl")}></RiClipboardLine>
                                            </div>
                                        </div>
                                        <textarea class="form-control " name="embeddUrl" value={eventEmbedd} onChange={(e) => setEmbeddUrl(e.target.value)} placeholder='paste Embedd url' rows="5" cols="30" />
                                       
                                        {/* <input type="text" class="form-control" name="embeddUrl" value={eventEmbedd} onChange={(e) => setEmbeddUrl(e.target.value)} placeholder='paste Embedd url' /> */}
                                    </div>
                                </div>

                                <div class="mb-3 row d-flex align-items-end p-0">
                                    <div className='col-md-8'>
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <label for="exampleFormControlTextarea1" class="form-label fw-bold">Image URL</label>
                                            </div>
                                            <div>
                                                <RiEraserFill className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Clear text" onClick={() => setImageUrl("")}></RiEraserFill>
                                                <RiClipboardLine className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Paste clipboard" onClick={() => pasteFromClipboard("image")}></RiClipboardLine>
                                            </div>
                                        </div>
                                        <input type="text" class="form-control" name="imageUrl" value={eventImage} onChange={(e) => setImageUrl(e.target.value)} placeholder='paste image url' />
                                    </div>
                                    <div className='col-md-4'>
                                        <button type="button" class="btn rounded-pill l-btn text-white" data-bs-toggle="modal" data-bs-target="#exampleModal"
                                            onClick={() => ChangeUploadUrl("https://app.mpp.in/polopolylite/akamai/akamaiupload1.php", "image")}>Upload Image</button>

                                    </div>
                                    {unsptdImageFormat ? <span style={{ color: "red" }}>*unsupported image format</span> : ""}
                                </div>
                                <div class="mb-3 row d-flex align-items-end p-0">
                                    <div className='col-md-8'>
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <label for="exampleFormControlTextarea1" class="form-label fw-bold">JW Video id</label>
                                            </div>
                                            <div>
                                                <RiEraserFill className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Clear text" onClick={() => setVideoUrl("")}></RiEraserFill>
                                                <RiClipboardLine className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Paste clipboard" onClick={() => pasteFromClipboard("video")}></RiClipboardLine>
                                            </div>
                                        </div>
                                        <input type="text" class="form-control" name="videoUrl" value={eventVideo} onChange={(e) => setVideoUrl(e.target.value)} placeholder='paste JW video id' />
                                    </div>
                                    <div className='col-md-4'>
                                        <button type="button" class="btn rounded-pill l-btn text-white mx-3" data-bs-toggle="modal" data-bs-target="#exampleModal"
                                            onClick={() => ChangeUploadUrl("https://brightcove.mathrubhumi.com/brightcove/pololite/jwplayer/code/index_new.php", "video")}>Upload video</button>
                                    </div>
                                    {unsptdVideoFormat ? <span style={{ color: "red" }}>*unsupported video format</span> : ""}
                                </div>
                                <div class="mb-3 row d-flex align-items-end p-0">
                                    <div className='col-md-8'>
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <label for="exampleFormControlTextarea1" class="form-label fw-bold">Audio URL</label>
                                            </div>
                                            <div>
                                                <RiEraserFill className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Clear text" onClick={() => setAudioUrl("")}></RiEraserFill>
                                                <RiClipboardLine className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Paste clipboard" onClick={() => pasteFromClipboard("audio")}></RiClipboardLine>
                                            </div>
                                        </div>
                                        <input type="text" class="form-control" name="audioUrl" value={eventAudio} onChange={(e) => setAudioUrl(e.target.value)} placeholder='paste audio url' />
                                    </div>
                                    <div className='col-md-4'>
                                        <button type="button" class="btn rounded-pill l-btn text-white" data-bs-toggle="modal" data-bs-target="#exampleModal"
                                            onClick={() => ChangeUploadUrl("https://app.mpp.in/audiostore/upload.php", "audio")}>Upload Audio</button>
                                    </div>
                                    {unsptdAudioFormat ? <span style={{ color: "red" }}>*unsupported audio format</span> : ""}
                                </div>

                                <div className='d-flex'>
                                    <button type="button" class="btn btn-primary " onClick={(e) => addEventPost(e)}>{submitAction === "edit" ? "Update" : "Submit"}</button>
                                    {submitAction === "edit" ? <button type="button" class="btn btn-danger" onClick={(e) => cancelEventPost(e)}>Cancel</button> : ""}
                                </div>


                            </form>
                        </div>
                    </div>
                    {/* <div className="col-md-1 d-flex justify-content-center">

                        <div className="l-horizontal-line">
                        </div>
                    </div> */}
                    <div className="col-md-6 l-event-post p-0 mb-3">
                        <div className="card border-0 l-event-post">
                            <div className="l-event-post-header p-3">
                                <h3 className="m-0">{params.name}</h3>
                            </div>
                            <div className="l-event-actions my-2 d-flex justify-content-between align-items-center px-3">
                                <div className="">
                                    {/* <h5 className="m-0">NEWS</h5> */}
                                    <p class="m-0 l-cursor" onClick={() => getEvents()}><RiRefreshLine className="mx-1" size={20} ></RiRefreshLine>Refresh</p>

                                </div>
                                <div className="d-flex l-event-actinos-btn">
                                    <Link to={`/preview/${params.id}/${params.name}`} target="_blank">
                                        <button type="button" class="btn mx-2 d-flex align-items-center"><RiNewspaperLine className="mx-1" size={20}></RiNewspaperLine>Preview</button>
                                    </Link>
                                    {/* <button type="button" class="btn mx-2 d-flex align-items-center"><RiEdit2Fill className="mx-1" size={20}></RiEdit2Fill>Edit</button> */}
                                    <button type="button" class="btn mx-2 d-flex align-items-center" onClick={() => embedCodeClick()}><RiCodeBoxLine className="mx-1" size={20}></RiCodeBoxLine>Embed Code</button>
                                </div>


                            </div>
                            {/* <div className="" style={{ backgroundColor: "#f6f6f6", width: "100%", height: "1px" }}></div> */}

                            <div className="l-event-news-list mt-3 p-3">
                                {/* <div className='l-event-poll my-3'>
                                    <p>{egPollData?.title}</p>
                                    <div className='l-event-poll-options'>
                                        <ol class="list-group">
                                            {egPollData?.options?.map((item, index) => (
                                                <li class="list-group-item" key={item.id}>{index + 1} - {item?.option} <div class="progress mt-2">
                                                    <div class="progress-bar " role="progressbar" style={{ width: `${votePercentagecalculator(item)}` }} aria-valuenow={`${votePercentagecalculator(item)}`} aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                                    <p className='m-0 pt-2' style={{ fontSize: "12px" }}>{votePercentagecalculator(item)} ({item?.vote} votes)</p>
                                                </li>
                                            ))}


                                        </ol>
                                    </div>
                                </div> */}
                                {
                                    listEventItems?.filter(e => e.status === "open").map((items) => (
                                        <div className="l-event-news px-2" key={items.Id}>
                                            <div className="l-event-news-head d-flex justify-content-between">
                                                <div className="l-event-news-time" style={{ backgroundColor: "grey", borderRadius: "5px", width: "max-content" }}>
                                                    <p className="m-0 text-white p-1 px-2" style={{ fontSize: "10px" }}>{convertTime(items.event_time)} , {dateFormat(items.event_time)}</p>
                                                </div>
                                                <div className="l-event-news-more-action d-flex me-3">
                                                    <p className="m-0 mx-2 l-cursor" onClick={() => evenetEditClick(items)} data-toggle="tooltip" data-placement="bottom" title="Edit"><RiEdit2Fill></RiEdit2Fill></p>
                                                    <p className="m-0 l-cursor mx-2" onClick={() => { setShowDeleteModal(true); setCurrentItem(items) }} data-toggle="tooltip" data-placement="bottom" title="Delete" ><RiDeleteBin5Line></RiDeleteBin5Line></p>

                                                </div>
                                            </div>
                                            <div className="l-event-news-content m-0 pt-3 malayalam">
                                                {items.event_imageurl ? <img src={items.event_imageurl} className="img-fluid mb-3" style={{ width: "100%" }} /> : ""}
                                                {/* {items.event_videourl ? <p style={{ height: "34vh" }}>
                                                    <iframe src={`https://cdn.jwplayer.com/players/${items.event_videourl}-dbzR9ypW.html`} allowfullscreen webkitallowfullscreen mozallowfullscreen style={{ top: "0px", right: "0px", bottom: "0px", left: "0px", width: "100%", height: "100%" }}></iframe> </p>
                                                    : ""} */}
                                                    {items?.event_videourl ? <div className='mpp-border-radius mpp-video-thumb-full mt-2 MyJWVideo'>
                            <div className="jwplayercontainer" data-mediaid={items.event_videourl} style={{ width: "100%", height: "100%" }}>
                            <ReactJWPlayer                            
                              playerId={items.event_videourl}
                              playerScript="https://content.jwplatform.com/libraries/dbzR9ypW.js"
                              playlist={`https://content.jwplatform.com/v2/media/${items.event_videourl}`}
                              // onReady={onReady}
                            />
                          </div>

                      </div>
                        : ""}
                                                {items?.event_audiourl ? <audio controls>
                                                    <source src={items.event_audiourl} type="audio/ogg" />
                                                    <source src={items.event_audiourl} type="audio/mpeg" />
                                                    Your browser does not support the audio element.
                                                </audio> : ""}

                                                <p dangerouslySetInnerHTML={createMarkup(items.event_description)}></p>
                                               
                                                <p dangerouslySetInnerHTML={createMarkup(items.event_embeddurl)}></p>
                                             
                                            </div>
                                            <p className="l-date m-0 pt-3 malayalam d-flex justify-content-end">created by: {items.created_at}</p>
                                            {items?.updated_by ?
                                                <p className="l-date m-0 malayalam d-flex justify-content-end">updated by: {items?.updated_by}</p> : ""}

                                            <hr></hr>
                                        </div>
                                    ))}


                            </div>

                        </div>
                    </div>
                </div >
            </Layout >


            <UploadUrl showModal={showModal} uploadUrl={uploadUrl} closeModal={() => setShowModal(false)}></UploadUrl>

            <ToastContainer />

            <EmbedCode data={embedData} showEmbedModal={showEmbedModal} closeModal={() => setShowEmbedModal(false)}></EmbedCode>

            <DeleteModal onDeleteFunction={() => eventDeleteClick()} onCancelFunction={() => setShowDeleteModal(false)} showDeleteModal={showDeleteModal}></DeleteModal>

            <ScoreEdit scoreUpdateParams={scoreUpdateParams} showScoreUpdateModal={showScoreUpdateModal} closeModal={() => setShowScoreUpdateModal(false)} teamDetails={(data) => setTeamDetailsFun(data)} ></ScoreEdit>

            <CreatePoll pollData={(data) => getPollDate(data)} showCreatePollModal={showCreatePollModal} closeModal={() => setShowCreatePollModal(false)}></CreatePoll>

        </div >
    )
}
